// extracted by mini-css-extract-plugin
export default {"container":"FormComponent_container__cQXDi","skipPaymentButton":"FormComponent_skipPaymentButton__wC4-b","skipPaymentContainer":"FormComponent_skipPaymentContainer__4SkW1"};